


















































































































import {
  defineComponent,
  reactive,
  SetupContext,
  Ref,
} from '@vue/composition-api'

import { NoticeState, UserState } from '@/types/store'

import useVuex from '@/utils/useVuex'

import { AppInput, AppAutocomplete } from '@/components/atoms'
import { IUser, UserRole } from '@/types/user'
import { INotice } from '@/types/notice'
import moment from 'moment'

type Props = {}

export default defineComponent({
  name: 'NoticeDetail',
  components: {
    AppInput,
    AppAutocomplete,
  },
  props: {},
  setup(props: Props, context: SetupContext) {
    const store = context.root.$store

    const state = reactive<{
      notice: Ref<INotice>
      user: Ref<IUser | null>
    }>({
      notice: useVuex<NoticeState['notice']>(
        context,
        () => store.getters['notice/notice'],
      ),
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
    })

    const onChangeTitle = (title: string) => {
      state.notice = {
        ...state.notice,
        title,
      }
    }

    const onChangeContent = (content: string) => {
      state.notice = {
        ...state.notice,
        content,
      }
    }

    const onSelectDistibuteForInfo = (distributeFor: UserRole) => {
      state.notice = {
        ...state.notice,
        distributeFor,
      }
    }

    const roleList: Record<string, string>[] = Object.entries(UserRole).map(
      ([key, value]) => {
        return { key, value }
      },
    )

    const save = async () => {
      if (state.user === null) {
        return
      }
      state.notice = {
        ...state.notice,
        createdById: state.user.id,
      }
      if (state.notice.id < 0) {
        await store.dispatch('notice/createNotice', state.notice)
        context.root.$router.go(-1)
        return
      }
      const error = await store.dispatch('notice/updateNotice', state.notice)
      if (error) {
        console.error(error)
      } else {
        context.root.$router.go(-1)
      }
    }

    const remove = async () => {
      if (confirm('この処理は元に戻すことができません。本当に実行しますか？')) {
        await store.dispatch('notice/deleteNotice', state.notice.id)
        context.root.$router.go(-1)
      }
    }

    const goBack = () => {
      context.root.$router.go(-1)
    }

    const formatForDisplay = (date: Date): string => {
      return moment(date).format('YYYY/MM/DD HH:mm:ss')
    }

    return {
      state,
      onChangeTitle,
      onChangeContent,
      onSelectDistibuteForInfo,
      roleList,
      save,
      remove,
      goBack,
      formatForDisplay,
    }
  },
})
